import { Asset } from "../../../shared/interfaces/Asset";
import MultiSelectAssetDropdown from "./MultiSelectAssetDropdown";
import SingleSelectAssetDropdown from "./SingleSelectAssetDropdown";

interface AssetDropdownProps {
  substationId?: number;
  onAssetChange: (selectedAssets: Asset[]) => void;
  width?: string;
  multiselect?: boolean;
  invalid?: boolean;
  invalidMessage: string;
  disabled?: boolean;
  selectedAssets?: Asset[];
  options: Asset[];
  disableErrorSpace?: boolean;
}

export default function AssetDropdown(props: AssetDropdownProps) {
  const selectedAsset = props.selectedAssets?.[0];

  return props.multiselect ? (
    <MultiSelectAssetDropdown {...props} />
  ) : (
    <SingleSelectAssetDropdown selectedAsset={selectedAsset} {...props} />
  );
}
